import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName
} from "../../../utility/index"
export default {
    name: "BatteryFile",
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                carId: '',
                batteryNumber: '',
                terminalId: '',
            },
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false,
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [{
                prop: "batteryNumber",
                label: this.$t('BatteryFile.batteryNumber'),
                align: "center",
            },
            {
                prop: "carId",
                label: this.$t('BatteryFile.carId'),
                align: "center",
            },
            {
                prop: "terminalId",
                label: this.$t('BatteryFile.terminalId'),
                align: "center",
            },
            {
                prop: "orgName",
                label: this.$t('BatteryFile.orgName'),
                align: "center",
            },

            {
                prop: "batteryType",
                label: this.$t('BatteryFile.batteryType'),
                align: "center",
                render: (h, params) => {
                    return h('el-tag', {
                        props: { type: params.row.batteryType == '' ? '' : params.row.batteryType == 1 ? this.$t('BatteryFile.plumbicAcid') : this.$t('BatteryFile.lithium') }
                    }, params.row.batteryType == '' ? '' : params.row.batteryType == 1 ? this.$t('BatteryFile.plumbicAcid') : this.$t('BatteryFile.lithium'))
                }
            },
            {
                prop: "power",
                label: this.$t('BatteryFile.power'),
                align: "center",
            },
            {
                prop: "capacity",
                label: this.$t('BatteryFile.capacity'),
                align: "center",
            },
            {
                prop: "ratedChargingSpeed",
                label: this.$t('BatteryFile.ratedChargingSpeed'),
                align: "center",
            },
            {
                prop: "ratedDischargeSpeed",
                label: this.$t('BatteryFile.ratedDischargeSpeed'),
                align: "center",
            },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            typeList: [],
            dialogFormVisible: false,
            formLabelWidth: '153px',
            diaTitle: '',
            btnType: '',
            rules: {
                batteryNumber: [{
                    required: true,
                    message: this.$t('BatteryFile.batteryNumber'),
                    trigger: 'blur'
                },],
            },
            form: {
                batteryNumber: '',
                carId: '',
                terminalId: '',
                batteryType: '',
                power: '',
                capacity: '',
                ratedChargingSpeed: '',
                ratedDischargeSpeed: '',
            },
            powerList: [
                {
                    id: "24V",
                    name: "24V"
                },
                {
                    id: "36V",
                    name: "36V"
                },
                {
                    id: "48V",
                    name: "48V"
                },
                {
                    id: "72V",
                    name: "72V"
                },
                {
                    id: "80V",
                    name: "80V"
                }
            ],
            disabled: false,
            isDisabled: false,
            dialogTransferFormVisible: false,
            LabelWidth: '104px',
            TransferRules: {},
            TransferForm: {
                batteryNumber: '',
                roleId: ''
            },
            BindRules: {},
            BindForm: {
                batteryNumber: '',
                carId: '',
                terminalId: ''
            },
            selected: [],
            id: '',
            name: '',
            dialogBatchFormVisible: false,
            dialogBindFormVisible: false,
        }
    },
    created() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getAllBattery()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getAllBattery()
        },
        getAllBattery() {
            let param = {
                orgId: this.id,
                carId: this.formInline.carId,
                batteryNumber: this.formInline.batteryNumber,
                terminalId: this.formInline.terminalId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('BatteryFile/GET_QUERYBATTERYPAGE', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllBattery()
        },
        onClear() {
            this.formInline = {
                carId: '',
                batteryNumber: '',
                terminalId: '',
            }
            this.getAllBattery()
        },
        addBattery() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.disabled = false
            this.isDisabled = false
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })
        },
        editBattery() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.disabled = true
            this.isDisabled = true
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
            })
            this.form.batteryNumber = this.selected[0].batteryNumber
            this.form.carId = this.selected[0].carId
            this.form.terminalId = this.selected[0].terminalId
            this.form.batteryType = String(this.selected[0].batteryType)
            this.form.power = this.selected[0].power
            this.form.capacity = this.selected[0].capacity
            this.form.ratedChargingSpeed = this.selected[0].ratedChargingSpeed
            this.form.ratedDischargeSpeed = this.selected[0].ratedDischargeSpeed
        },
        Relieve() {
            this.$confirm(this.$t('common.btn.bindText'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    id: this.selected[0].id,
                    batteryType: 1,
                    carId: '',
                };
                this.$store.dispatch('BatteryFile/GET_BATTERYBINDING', param).then(response => {
                    if (response.data.code == 200) {
                        this.dialogFormVisible = false;
                        this.getAllBattery();
                        this.$message.success(this.$t('common.btn.unBindSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },
        isRelieve() {
            this.$confirm(this.$t('common.btn.bindText'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    id: this.selected[0].id,
                    batteryType: 2,
                    terminalId: '',
                };
                this.$store.dispatch('BatteryFile/GET_BATTERYBINDING', param).then(response => {
                    if (response.data.code == 200) {
                        this.dialogFormVisible = false;
                        this.getAllBattery();
                        this.$message.success(this.$t('common.btn.unBindSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        orgId: this.id,
                        carId: this.form.carId,
                        batteryNumber: this.form.batteryNumber,
                        terminalId: this.form.terminalId,
                        batteryType: this.form.batteryType,
                        power: this.form.power,
                        capacity: this.form.capacity,
                        ratedChargingSpeed: this.form.ratedChargingSpeed,
                        ratedDischargeSpeed: this.form.ratedDischargeSpeed,
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('BatteryFile/GET_INSERTBATTERY', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllBattery();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        param.id = this.selected[0].id
                        this.$store.dispatch('BatteryFile/GET_UPDATEBATTERY', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllBattery();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }


                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                batteryNumber: '',
                carId: '',
                batteryType: '',
                power: '',
                capacity: '',
                ratedChargingSpeed: '',
                ratedDischargeSpeed: '',
            }
        },
        closeDia() {
            this.form = {
                batteryNumber: '',
                carId: '',
                batteryType: '',
                power: '',
                capacity: '',
                ratedChargingSpeed: '',
                ratedDischargeSpeed: '',
            }
            this.dialogFormVisible = false;
        },
        deleteBattery() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    id: this.selected.map(item => item.id).join()
                }
                this.$store.dispatch('BatteryFile/GET_DELETEBATTERYBYID', param).then(response => {
                    if (response.data.code == 200) {
                        this.getAllBattery()
                        this.$message.success(this.$t('common.btn.deleteSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },
        transferBattery() {
            this.dialogTransferFormVisible = true
            this.TransferForm.batteryNumber = ''
            this.selected.map(item => {
                if (this.selected.length > 1) {
                    this.TransferForm.batteryNumber = this.TransferForm.batteryNumber.concat((item.batteryNumber + '-' + item.orgName + ','))
                } else {
                    this.TransferForm.batteryNumber = this.TransferForm.batteryNumber.concat((item.batteryNumber + '-' + item.orgName))
                }
            })
        },
        changeClick(val) {
            this.roleId = val.label
        },
        submitTransferForm(TransferFormName) {
            this.$refs[TransferFormName].validate((valid) => {
                if (valid) {
                    let batteryNumbers = ''
                    this.selected.map((item, index) => {
                        if (index == 0) {
                            batteryNumbers = item.batteryNumber
                        } else {
                            batteryNumbers = batteryNumbers + ',' + item.batteryNumber
                        }
                    })
                    let param = {
                        batteryNumber: batteryNumbers,
                        orgId: this.roleId
                    }
                    this.$store.dispatch('BatteryFile/GET_BATTERYAPPROPRIATE', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.transferSuccess'))
                            this.dialogTransferFormVisible = false;
                            this.getAllBattery();
                            this.closeTransfer();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })
                } else {
                    return false;
                }
            });
        },
        cancleTransfer(TransferFormName) {
            this.dialogTransferFormVisible = false;
            this.TransferForm = {
                batteryNumber: '',
                roleId: ''
            }
        },
        closeTransferDia() {
            this.TransferForm = {
                batteryNumber: '',
                roleId: ''
            }
            this.dialogTransferFormVisible = false;
        },
        bindBattery() {
            this.dialogBindFormVisible = true;
            this.BindForm.batteryNumber = this.selected[0].batteryNumber
            this.BindForm.carId = this.selected[0].carId
            this.BindForm.terminalId = this.selected[0].terminalId
        },
        submitBindForm(BindFormName) {
            this.$refs[BindFormName].validate((valid) => {
                if (valid) {
                    let param = {
                        id: this.selected[0].id,
                        batteryType: 0,
                        carId: this.BindForm.carId,
                        terminalId: this.BindForm.terminalId,
                        batteryNumber: this.BindForm.batteryNumber
                    }
                    this.$store.dispatch('BatteryFile/GET_BATTERYBINDING', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.bindSuccess'))
                            this.dialogBindFormVisible = false;
                            this.getAllBattery();
                            this.closeBindDia();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })
                } else {
                    return false;
                }
            });
        },
        cancleBind(BindFormName) {
            this.dialogBindFormVisible = false;
            this.BindForm = {
                carId: '',
                batteryNumber: '',
                terminalId: ''
            }
        },
        closeBindDia() {
            this.BindForm = {
                carId: '',
                batteryNumber: '',
                terminalId: ''
            }
            this.dialogBindFormVisible = false;
        },
        
        BulkImport() {
            this.dialogBatchFormVisible = true
        },
        
        TemplateFile() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/uploadBatteryModel`
                    location.href = url
                   
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/uploadBatteryModel`
                    location.href = url
                    
                }
            }
        },
        
        uploadBattery(e) {
            let dom = document.getElementById('uploadDom')
            let file = dom.files[0];
            let companyId = sessionStorage.getItem('companyId')
            let formData = new FormData()
            formData.append('File', file)
            formData.append('companyId', companyId)
            let types = file.name.split('.')[1]
            if (types != "xlsx" && types != "xls") {
                this.$message.error(this.$t('BatteryFile.form.choseExcel'));
                return false;
            } else {
                this.$store.dispatch('BatteryFile/GET_UPLOADBATTERY', formData).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                        this.dialogBatchFormVisible = false;
                        this.getAllBattery()
                    } else {
                        this.$message.error(res.data.msg)
                    }
                    document.getElementById('uploadDom').value = ''
                }).catch(err => {
                    this.$message.error(this.$t('common.btn.fileUploadError'))
                    document.getElementById('uploadDom').value = ''
                })
            }
        },
        closeBatchDia() {
            this.dialogBatchFormVisible = false
        },
        downBattery() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportBattery?orgId=${this.id}&carId=${this.formInline.carId}&batteryNumber=${this.formInline.batteryNumber}&terminalId=${this.formInline.terminalId}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportBattery?orgId=${this.id}&carId=${this.formInline.carId}&batteryNumber=${this.formInline.batteryNumber}&terminalId=${this.formInline.terminalId}`
                    location.href = url


                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllBattery();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}